<template>
    <Modal class="tiw__step__howYouRateDevice">
        <template #header>
            <template v-if="HowYouRateDeviceStore.isBack">
                <p class="tiw__h2">
                    {{ HowYouRateDeviceStore.questionData.question }}
                </p>
                <p>{{ HowYouRateDeviceStore.questionData.description }}</p>
            </template>
            <template v-else>
                <p class="tiw__h2">
                    {{ HowYouRateDeviceStore.questionData.question }}
                </p>
            </template>
        </template>

        <div class="tiw__step__howYouRateDevice__body">
            <form name="howYouRateDeviceForm">
                <HandedDevice
                    :device-price="HowYouRateDeviceStore.handedDevicePrice"
                    :device-chain="ChooseDeviceStore.deviceChain"
                    :device-state="!HowYouRateDeviceStore.isBack && HowYouRateDeviceStore.rate"
                    :device-preview="ChooseDeviceStore.deviceImagePreview"
                    :device-grade="null"
                    :device-no-grade="false"
                    :device-terminated="false"
                    :on-edit="onEditHandler"
                />

                <Notification
                    v-if="
                        TIWStore.INJECTED_GOOD &&
                        HowYouRateDeviceStore.showWarningNotificationMinOrder(
                            TIWStore.minOrderPrice,
                        )
                    "
                    type="warning"
                    class="tiw__step__howYouRateDevice__body__notification"
                >
                    {{ useTranslate("tiw__howYouRateDevice__warningNotification__minOrder") }}
                </Notification>

                <CalculatedDevice
                    v-if="
                        !HowYouRateDeviceStore.isBack &&
                        !TIWStore.domainIsTakealot &&
                        TIWStore.INJECTED_GOOD
                    "
                    :calculated-data="HowYouRateDeviceStore.calculatedDeviceData"
                />

                <div
                    v-if="HowYouRateDeviceStore.isBack"
                    :class="{
                        'tiw__rate-chooser': true,
                        'tiw__rate-chooser_loading': loadingToNext,
                    }"
                >
                    <div
                        v-for="chooserItem in HowYouRateDeviceStore.questionData.options"
                        :key="chooserItem.cid"
                        class="tiw__rate-chooser__element"
                    >
                        <input
                            :id="`howYouRateDeviceForm__rate_${chooserItem.cid}`"
                            v-model="HowYouRateDeviceStore.rate"
                            class="tiw_hidden"
                            type="radio"
                            name="rate"
                            :value="chooserItem.cname"
                        />
                        <label
                            :for="`howYouRateDeviceForm__rate_${chooserItem.cid}`"
                            class="tiw__rate-chooser__item"
                            @click="selectRateHandler($event, chooserItem.cid)"
                        >
                            <figure class="tiw__rate-chooser__figure">
                                <img :src="chooserItem.imageVariant" :alt="chooserItem.cname" />
                            </figure>
                            <div class="tiw__rate-chooser__body">
                                <p class="tiw__rate-chooser__title">
                                    {{ chooserItem.cname }}
                                </p>
                                <p class="tiw__rate-chooser__text">
                                    {{ chooserItem.description }}
                                </p>
                            </div>
                        </label>
                    </div>
                </div>
            </form>

            <!-- Инфо-блок с пояснением как получить скидку -->
            <template v-if="!HowYouRateDeviceStore.isBack && !HowYouRateDeviceStore.isNoPhotoSet">
                <div class="tiw__step__howYouRateDevice__info">
                    <!-- new -->
                    <p class="tiw__title">
                        {{ useTranslate("tiw__howYouRateDevice__discount__right__now") }}
                    </p>
                    <div class="tiw__step__howYouRateDevice__discount_info_container">
                        <div class="tiw__step__howYouRateDevice__discount_items">
                            <div
                                v-for="(item, i) in howGetDiscountRightNow"
                                :key="'how_you_rate_' + i"
                                class="tiw__step__howYouRateDevice__discount_item"
                            >
                                <div class="tiw__step__howYouRateDevice__discount_icon">
                                    <img
                                        width="30"
                                        height="30"
                                        :src="item.icon"
                                        alt="how get icons"
                                    />
                                    <div
                                        v-if="i + 1 !== howGetDiscountRightNow.length"
                                        class="tiw__step__howYouRateDevice__discount_icons__slash"
                                    />
                                </div>
                                <div class="tiw__step__howYouRateDevice__discount_info">
                                    <p class="tiw__step__howYouRateDevice__discount_title">
                                        {{ item.title }}
                                    </p>
                                    <p class="tiw__step__howYouRateDevice__discount_text">
                                        {{ item.text }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="TIWStore.hasDiscountLater"
                        class="tiw__step__howYouRateDevice__discount_switch_container"
                    >
                        <Switch v-model="TIWStore.isDiscountLater" />
                        <div class="tiw__step__howYouRateDevice__discount_switch_info">
                            <p class="tiw__step__howYouRateDevice__discount_title">
                                {{
                                    useTranslate(
                                        "tiw__howYouRateDevice__discount__right__button__get__title",
                                    )
                                }}
                            </p>
                            <p class="tiw__step__howYouRateDevice__discount_text">
                                {{
                                    useTranslate(
                                        "tiw__howYouRateDevice__discount__right__button__get__text",
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                    <!-- new -->

                    <p v-if="TIWStore.isPickupOnly" class="tiw__text">
                        {{ useTranslate("tiw__howYouRateDevice__pickup_only_info") }}
                    </p>
                </div>
                <div class="tiw_group tiw_group-sb">
                    <BackButton @click="clickToBackHandler" />
                    <Button
                        type="button"
                        class="tiw__step__howYouRateDevice__btn-next tiw__btn-next"
                        @click="clickToNext"
                    >
                        <span>{{ useTranslate("tiw__continue") }}</span>
                    </Button>
                </div>
            </template>

            <!-- Инфо-блок с пояснением что надо идти в магазин -->
            <template v-if="!HowYouRateDeviceStore.isBack && HowYouRateDeviceStore.isNoPhotoSet">
                <div class="tiw__step__howYouRateDevice__info">
                    <p class="tiw__title">
                        {{ useTranslate("tiw__howYouRateDevice__howGetSale") }}
                    </p>
                    <p class="tiw__text">
                        {{ useTranslate("tiw__howYouRateDevice__howGetSale_info_goShop") }}
                    </p>
                </div>
                <div class="tiw_group tiw_group-sb">
                    <Button
                        type="button"
                        variant="skeleton"
                        class="tiw__step__howYouRateDevice__btn-restart"
                        @click="clickRestartHandler"
                    >
                        <RefreshIcon />
                        <span>{{ useTranslate("tiw__restart") }}</span>
                    </Button>
                    <Button
                        type="button"
                        class="tiw__step__howYouRateDevice__btn-next tiw__btn-close"
                        @click="clickToClose"
                    >
                        <span>{{ useTranslate("tiw__close") }}</span>
                    </Button>
                </div>
            </template>
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "HowYouRateDevice",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [HowYouRateDevice]
 * Модальное окно / экран "Как вы оцениваете ваше устройство"
 * */

import { computed, ref } from "vue";

import dontMissIcon from "@/assets/img/dont-miss.svg";
import getPriceIcon from "@/assets/img/get-price.svg";
import snapPicIcon from "@/assets/img/snap-pic.svg";
import CalculatedDevice from "@/components/calculatedDevice/calculatedDevice.vue";
import HandedDevice from "@/components/handedDevice/handedDevice.vue";
import Modal from "@/components/modal/modal.vue";
import Notification from "@/components/notification/notification.vue";
import { useBugTracker, BugTrackerSection } from "@/helpers/bugTracker";
import { deviceGradeNormalize } from "@/helpers/deviceGrade";
import it4SendAnswerQuestion from "@/hooks/requests/it4SendAnswerQuestion/it4SendAnswerQuestion";
import {
    useAnalyticsEventPrePrice,
    useAnalyticsEventImei,
    useAnalyticsEventTiModel,
} from "@/hooks/useAnalytics/useAnalytics";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTradeInCalculation from "@/hooks/useTradeInCalculation/useTradeInCalculation";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { GRADES_DATA } from "@/stores/howYouRateDevice/howYouRateDevice.model";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import RefreshIcon from "@/ui/icons/refresh.vue";
import { apiGetFirstQuestions } from "~/tiw/hooks/requests/apiGetQuestions/apiGetFirstQuestions";
import BackButton from "~/tiw/ui/button/backButton/backButton.vue";
import Switch from "~/tiw/ui/switch/switch.vue";

const TIWStore = useTIWStore();
const ChooseDeviceStore = useChooseDeviceStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();

const loadingToNext = ref<boolean>(false);

const onEditHandler = () => {
    if (loadingToNext.value) return;

    HowYouRateDeviceStore.restoreToDefault();
    ChooseDeviceStore.restoreToDefault();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
};

const selectRateHandler = async (_: MouseEvent, cid: string) => {
    loadingToNext.value = true;

    useAnalyticsEventPrePrice();

    try {
        // Ответить на вопрос о статусах оценки
        const answerQuestionData = await it4SendAnswerQuestion({
            token: TIWStore.WIDGET_DATA.token, // "d7bd115c-e845-4381-8f11-8044cbc11dfe",
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId, // deviceID сдаваемого устройства
            lang: TIWStore.standardizedLocale,
            c: cid,
            ans: "",
            questionId: HowYouRateDeviceStore.questionData.questionId,
            from: "3",
        });

        // useBugTracker("HowYouRateDevice - it4SendAnswerQuestion (response)", BugTrackerSection.INFO, {
        //     response: answerQuestionData,
        // });

        // Устанавливаем значение грейда из ответа ответа на вопрос
        HowYouRateDeviceStore.grade = deviceGradeNormalize(answerQuestionData.device.grade);

        // Устанавливаем описание значения грейда "Как новый", "С дефектами"
        HowYouRateDeviceStore.rate = useTranslate(
            `tiw__grades__${GRADES_DATA[answerQuestionData.device.grade].gradeCode}_stateInfo`,
        );

        useTradeInCalculation({
            tradeInPrice: answerQuestionData.device.price,
            isWithoutActionSale: answerQuestionData.device.additionalDiscountValue === 0,
        });
    } catch (e) {
        useBugTracker("HowYouRateDevice - it4SendAnswerQuestion", BugTrackerSection.ERROR, {
            exception: e.message,
            request: {
                token: TIWStore.WIDGET_DATA.token, // "d7bd115c-e845-4381-8f11-8044cbc11dfe",
                deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId, // deviceID сдаваемого устройства
                lang: TIWStore.standardizedLocale,
                c: cid,
                ans: "",
                questionId: HowYouRateDeviceStore.questionData.questionId,
                from: "3",
            },
        });
    }

    loadingToNext.value = false;

    // Потом продвигаемся на шаг вперед
    HowYouRateDeviceStore.isBack = false;
};

const clickToBackHandler = async () => {
    HowYouRateDeviceStore.isBack = true;
};

const clickToNext = async () => {
    if (TIWStore.isDiscountLater) {
        HowYouRateDeviceStore.discountLaterFirstQuestion = await apiGetFirstQuestions({
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            lang: TIWStore.standardizedLocale,
            questionId: "",
            token: TIWStore.WIDGET_DATA.token,
        });
        TIWStore.switchStep("visualEvaluation");
    } else {
        TIWStore.switchStep("enterImei");
    }
    useAnalyticsEventImei();
};

const clickRestartHandler = async () => {
    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
};

const clickToClose = async () => {
    TIWStore.closeWidget();
    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
};

const howGetDiscountRightNow = [
    {
        title: useTranslate("tiw__howYouRateDevice__discount__right__now__snap__title"),
        text: useTranslate("tiw__howYouRateDevice__discount__right__now__snap__text"),
        icon: snapPicIcon,
    },
    {
        title: useTranslate("tiw__howYouRateDevice__discount__right__now__online__price__title"),
        text: useTranslate("tiw__howYouRateDevice__discount__right__now__online__price__text"),
        icon: getPriceIcon,
    },
    {
        title: useTranslate(
            TIWStore.domainIsTakealot
                ? "tiw__howYouRateDevice__discount__right__now__dont__miss__title_takealot"
                : "tiw__howYouRateDevice__discount__right__now__dont__miss__title",
        ),
        text: useTranslate(
            TIWStore.domainIsTakealot
                ? "tiw__howYouRateDevice__discount__right__now__dont__miss__text_takealot"
                : "tiw__howYouRateDevice__discount__right__now__dont__miss__text",
        ),
        icon: dontMissIcon,
    },
];
</script>

<style lang="scss" src="./howYouRateDevice.scss"></style>
